import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import SmtpSettings from './SmtpSettings';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../hooks/use-toast';
import { Toaster } from '../components/ui/toaster';
import NavigationMenu from '../components/NavigationMenu';
import DynamicFooter from '../components/DynamicFooter';

const AdminSMTP = () => {
  const { token } = useAuth();
  const { toast } = useToast();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex flex-col">
      <Toaster />
      <NavigationMenu />
      
      <main className="flex-1 pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center gap-4 mb-8">
            <Link to="/admin/dashboard?tab=settings" className="text-blue-400 hover:text-blue-300 transition-colors">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <Mail className="w-6 h-6 text-blue-400" />
            <h1 className="text-xl font-semibold text-white">Configuration SMTP</h1>
          </div>
          <SmtpSettings token={token} toast={toast} />
        </div>
      </main>
      
      <DynamicFooter fixed={true} />
    </div>
  );
};

export default AdminSMTP;
